import React from 'react';
import image from '../assets/images/failed.jpg'

const FailedImage = () => {
    return <center style={{ background: 'white', padding: 50 }}>
    <img width="400" src={image} alt="failed transaction" />

</center>
}
export default FailedImage;